import React from "react";
import Racheal from "../component/images/racheal.png";
import Navbar from "./navBar";
import Interests from "./reusable/intrests";
import Count from "./reusable/counts";
import Skills from "./reusable/skills";
import "./styles/about.css";
import "boxicons";

function About() {
  return (
    <div>
      <Navbar />
      <section id="about" className="about">
        {/* <!-- ======= About Me ======= --> */}
        <div className="about-me container">
          <div className="section-title">
            <h2>About</h2>
            <p>Learn more about me</p>
          </div>

          <div className="row gx-5">
            <div className="col-lg-4 p-0 border border-white">
              <img src={Racheal} className="img-fluid pl-lg-4" alt="" />
            </div>
            <div className="col-lg-8 pt-4 pt-lg-0 content ">
              <h3>Software &amp; Developer</h3>
              <p className="font-italic">
              Using my acquired knowledge and skills to aid organizational growth, effectiveness, and efficiency in its objectives and policies. To impact my knowledge and skills to others.

              </p>
              <div className="row">
                <div className="col-lg-6">
                  <ul>
                    {/* <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>Birthday:</strong> 00.00.00
                    </li> */}
                    {/* <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>Website:</strong> www.example.com
                    </li> */}
                    <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>Phone:</strong> +234 708 629 2088
                    </li>
                    <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>City:</strong> Lagos, Nigeria.
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul>
                    {/* <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong className="pl-1">Nationality:</strong> Nigeria
                    </li> */}
                    {/* <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>Degree:</strong> Master
                    </li> */}
                    <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>Email:</strong> emilychealy4@gmail.com
                    </li>
                    <li>
                      <box-icon
                        name="radio-circle-marked"
                        color="white"
                      ></box-icon>
                      <strong>Freelance:</strong> Available
                    </li>
                  </ul>
                </div>
              </div>
              <p>
                I am industrious, hardworking and obedient. I believe in
                teamwork though I can work personally. I devote myself to teach
                others the skills I am acquainted with . A focused task oriented
                person who has abilities to solve problems and ability to
                present ideas. I am keen on information and detail. I can manage
                resources usefully and above all I am ever ready to learn new
                things and I flair for success and achievement.
              </p>
            </div>
          </div>
        </div>
        {/* <!-- End About Me --> */}

        {/* <!-- ======= Counts ======= --> */}
        <div className="counts container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <Count />
            </div>

            <div className="col-lg-3 col-md-6 mt-5 mt-md-0">
              <Count name="Projects" number="5" emojiName="folder-open" />
            </div>

            <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
              <Count
                name="Volunteer Service"
                number="6"
                emojiName="calendar-event"
              />
            </div>

            <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
              <Count name="Articles" number="5" emojiName="book" />
            </div>
          </div>
        </div>
        {/* <!-- End Counts --> */}

        {/* <!-- ======= Skills  ======= --> */}
        <div className="skills container">
          <div className="section-title">
            <h2>Skills</h2>
          </div>

          <div className="row skills-content">
            <div className="col-lg-6">
              <Skills />

              <Skills skill="CSS" value="90%" width="90" />

              <Skills skill="Javascript" value="84%" width="77" />
            </div>

            <div className="col-lg-6">
              <Skills skill="React" value="90%" width="90" />

              <Skills skill="Wordpress/CMS" value="90%" width="89" />

              <Skills skill="Figma" value="60%" width="60" />
            </div>
          </div>
        </div>
        {/* <!-- End Skills --> */}

        {/* <!-- ======= Interests ======= --> */}
        <div className="interests container">
          <div className="section-title">
            <h2>Interests</h2>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4">
              <Interests />
            </div>
            <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
              <Interests
                intrest="Reading"
                emojiName="book"
                emojiColor="green"
              />
            </div>
            <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
              <Interests
                intrest="Travelling"
                emojiName="plane-alt"
                emojiColor="orange"
              />
            </div>
            <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
              <Interests
                intrest="Networking"
                emojiName="book"
                emojiColor="green"
              />
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <Interests
                intrest="Learning"
                emojiName="book"
                emojiColor="green"
              />
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <Interests
                intrest="Blockchain"
                emojiName="book"
                emojiColor="green"
              />
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <Interests
                intrest="Virtual Reality"
                emojiName="book"
                emojiColor="green"
              />
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <Interests
                intrest="Volley Ball"
                emojiName="book"
                emojiColor="green"
              />
            </div>
          </div>
        </div>
        {/* <!-- End Interests --> */}

        {/* <!-- ======= Testimonials ======= --> */}
        {/* <div className="testimonials container">
          <div className="section-title">
            <h2>Testimonials</h2>
          </div>

          <div className="owl-carousel testimonials-carousel">
            <div className="testimonial-item">
              <p>
                <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                Proin iaculis purus consequat sem cure digni ssim donec
                porttitora entum suscipit rhoncus. Accusantium quam, ultricies
                eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.
                <i className="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-1.jpg"
                className="testimonial-img"
                alt=""
              />
              <h3>Saul Goodman</h3>
              <h4>Ceo &amp; Founder</h4>
            </div>

            <div className="testimonial-item">
              <p>
                <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                Export tempor illum tamen malis malis eram quae irure esse
                labore quem cillum quid cillum eram malis quorum velit fore eram
                velit sunt aliqua noster fugiat irure amet legam anim culpa.
                <i className="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-2.jpg"
                className="testimonial-img"
                alt=""
              />
              <h3>Sara Wilsson</h3>
              <h4>Designer</h4>
            </div>

            <div className="testimonial-item">
              <p>
                <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                Enim nisi quem export duis labore cillum quae magna enim sint
                quorum nulla quem veniam duis minim tempor labore quem eram duis
                noster aute amet eram fore quis sint minim.
                <i className="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-3.jpg"
                className="testimonial-img"
                alt=""
              />
              <h3>Jena Karlis</h3>
              <h4>Store Owner</h4>
            </div>

            <div className="testimonial-item">
              <p>
                <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                Fugiat enim eram quae cillum dolore dolor amet nulla culpa
                multos export minim fugiat minim velit minim dolor enim duis
                veniam ipsum anim magna sunt elit fore quem dolore labore illum
                veniam.
                <i className="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-4.jpg"
                className="testimonial-img"
                alt=""
              />
              <h3>Matt Brandon</h3>
              <h4>Freelancer</h4>
            </div>

            <div className="testimonial-item">
              <p>
                <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                Quis quorum aliqua sint quem legam fore sunt eram irure aliqua
                veniam tempor noster veniam enim culpa labore duis sunt culpa
                nulla illum cillum fugiat legam esse veniam culpa fore nisi
                cillum quid.
                <i className="bx bxs-quote-alt-right quote-icon-right"></i>
              </p>
              <img
                src="assets/img/testimonials/testimonials-5.jpg"
                className="testimonial-img"
                alt=""
              />
              <h3>John Larson</h3>
              <h4>Entrepreneur</h4>
            </div>
          </div>
        </div> */}
        {/* End Testimonials   */}
      </section>
    </div>
    // </div>
  );
}

export default About;
